import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const InspireMe = React.lazy(() => import("@mediaspace/features/inspire-me"));

export const render = getDsLayoutComponentRenderer(InspireMe);
